export const SERVER_BASE_URL = process.env.VUE_APP_BASE_URL;

// mock api
export const MOCK = {
  MOCK_200: "/mock/200",
  MOCK_401: "/mock/401",
  MOCK_403: "/mock/403",
  MOCK_404: "/mock/404",
  MOCK_500: "/mock/500",
  MOCK_503: "/mock/503",
};

export const API_HOME_VIDEO = "/home/video";
